import { Component, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppMenu } from './app.menu';
import { SidebarLockService } from './submenu-panel/sidebar-lock.service';
import { VerticalConfigService } from '@/pages/service/core/vertical-config.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [CommonModule, RouterModule, AppMenu],
    template: `
        <div class="layout-sidebar"
             [class.locked-expanded]="locked"
             (click)="onClick()"
             (mouseleave)="onMouseLeave($event)">
            <a class="lm-brand" routerLink="/dashboard" aria-label="Home">
                <img [src]="brand.logoObjectUrl() || 'assets/logo-grow.png'" alt="Logo" />
            </a>
            <app-menu></app-menu>
        </div>
    `
})
export class AppSidebar implements OnInit, OnDestroy {

    private lockService = inject(SidebarLockService);
    brand = inject(VerticalConfigService);
    locked = false;
    private sub?: Subscription;

    constructor(public el: ElementRef) {}

    ngOnInit(): void {
        this.sub = this.lockService.isLocked().subscribe(v => this.locked = v);
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    onClick(): void {
        this.lockService.setLocked(true);
    }

    onMouseLeave(event: MouseEvent): void {
        // If the pointer is moving into the submenu panel, keep the sidebar
        // expanded. Otherwise release the lock so the sidebar collapses.
        const target = event.relatedTarget as Element | null;
        if (target && target.closest && target.closest('app-submenu-panel')) {
            return;
        }
        this.lockService.setLocked(false);
    }
}
